import { PageHeading } from 'components/atoms/Text'
import { SingleColumnLayout } from 'components/layouts/Layouts'
import InternalLayoutContainer from 'components/features/pfm/InternalLayout/InternalLayoutContainer'
import InternalSidebarContainer from 'components/features/pfm/InternalSidebar/InternalSidebarContainer'
import ModuleWrapper2020 from 'components/features/pfm/ModuleWrapper2020/ModuleWrapper2020'
import { NotificationTrayWrapper } from 'components/features/pfm/NotificationTray/NotificationTrayWrapper'
import { PageAnchorHandler } from 'handlers/PageAnchorHandler/PageAnchorHandler'
import { REWARDS_PAGE } from 'constants/pages'
import { FC, useCallback, useMemo } from 'react'
import * as styles from 'components/features/rewards/rewardPage/RewardPage/RewardPage.styl'
import RewardDetailsContainer from 'components/features/pfm/RewardDetails/RewardDetailsContainer'
import RedemptionsModuleContainer from 'components/features/pfm/RedemptionsModule/RedemptionsModuleContainer'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { toggleRewardDetailsModalActionCreator } from 'actions/bountyActions'
import { LifetimeEarnings } from 'components/features/rewards/rewardPage/LifetimeEarnings/LifetimeEarnings'
import { RewardsPageCryptoWallet } from 'components/features/rewards/rewardPageCryptoWallet/RewardsPageCryptoWallet/RewardsPageCryptoWallet'
import { WaysToEarn } from 'components/features/rewards/rewardPage/WaysToEarn'
import { RewardPageModuleWrapper } from 'components/features/rewards/rewardPage/RewardPage/RewardPageModuleWrapperPreset'
import { HowRewardsWorks } from 'components/features/rewards/rewardPage/HowRewardsWorks/HowRewardsWorks'
import { RewardsSummaryModule } from 'components/features/rewards/rewardPageSummary/RewardsSummaryModule/RewardsSummaryModule'
import { InternalPageRedirect } from 'components/features/pfm/InternalPageRedirect/InternalPageRedirect'
import ModuleLayout from 'components/atoms/ModuleLayout/ModuleLayout'
import Button from 'components/features/pfm/Button/Button'

export const RewardPage: FC = () => {
  const notificationsChild = useMemo(() => (
    <NotificationTrayWrapper
      renderLevel='page'
      isPositionRelative
    />
  ), [])

  const sidebarChild = useMemo(() => (
    <InternalSidebarContainer />
  ), [])

  const summaryChild = useMemo(() => (
    <PageAnchorHandler placement='rewards_summary'>
      <RewardsSummaryModule
        className={ styles.fullHeight }
      />
    </PageAnchorHandler>
  ), [])

  const waysToEarnChild = useMemo(() => (
    <RewardPageModuleWrapper
      forceRoundedCorners
      withPaddingBottom
      isContentFlexLayout
      isFlexLayout
      title='Ways To Earn'
      corners='all'
      shadowTheme='regular'
      className={ styles.fullHeight }
    >
      <WaysToEarn />
    </RewardPageModuleWrapper>
  ), [])


  const dispatch = useStoreDispatch()
  const handleTooltipClick = useCallback(() => {
    dispatch(toggleRewardDetailsModalActionCreator('cash'))
  }, [dispatch])


  const rewardDetailsHintChild = useMemo(() => (
    <>
      Click
      <Button text='here' style='asText' className={ styles.link } onClick={ handleTooltipClick } >
        &nbsp;here&nbsp;
      </Button>
      to learn more about tracking your reward's progress
    </>
  ), [handleTooltipClick])

  return (
    <InternalPageRedirect>
      <PageAnchorHandler placement={ REWARDS_PAGE }>
        <div className={ styles.anchorPlaceholder } />
      </PageAnchorHandler>

      <InternalLayoutContainer
        sidebar={ sidebarChild }
        notifications={ notificationsChild }
      >
        <SingleColumnLayout>
          <PageHeading>
            Your Rewards
          </PageHeading>

          <div className={ styles.grid }>

            <div className={ styles.summary }>
              { summaryChild }
            </div>
            <div className={ styles.howItWorks }>
              <PageAnchorHandler placement='rewards_description'>
                <ModuleWrapper2020
                  title='How It Works'
                  corners='all'
                  forceRoundedCorners
                  shadowTheme='regular'
                  className={ styles.moduleWrapper }
                >
                  <HowRewardsWorks />
                </ModuleWrapper2020>
              </PageAnchorHandler>
            </div>
            <div className={ styles.lifetime }>
              <LifetimeEarnings className={ styles.moduleWrapper } />
            </div>
            <div className={ styles.waysToEarn }>
              { waysToEarnChild }
            </div>
            <div className={ styles.content }>
              <RewardsPageCryptoWallet className={ styles.moduleWrapper } />

              <PageAnchorHandler placement='rewards_details'>
                <ModuleLayout
                  title='Reward Details'
                  hint={ rewardDetailsHintChild }
                  cardLayout={ false }
                  marginBottom='xlarge'
                >
                  <RewardDetailsContainer />
                </ModuleLayout>
              </PageAnchorHandler>

              <PageAnchorHandler placement='rewards_redemptions'>
                <ModuleWrapper2020
                  title='Redemptions'
                  card={ false }
                  corners='all'
                  forceRoundedCorners
                  shadowTheme='regular'
                  className={ styles.moduleWrapper }
                >
                  <RedemptionsModuleContainer />
                </ModuleWrapper2020>
              </PageAnchorHandler>
            </div>
          </div>

        </SingleColumnLayout>
      </InternalLayoutContainer>
    </InternalPageRedirect>
  )
}
